import ApiUtils from '@/utils/ApiUtils';
import {Route} from 'vue-router';
import {VueRouter} from 'vue-router/types/router';
import {CommonModelUtils, Privilege} from '@/model/CommonModel';

export default class CommonUtils {
    public static routeLanguage($route: Route, $router: VueRouter, language: string, additionals: any = {}): Promise<any> {
        if (!$route.name) {
            return Promise.resolve();
        }
    
        const name: string = $route.name;
        return $router.push({
            name,
            params: {
                ...ApiUtils.extractRequiredParams($route.params),
                language,
                ...additionals
            }
        });
    }
    
    public static routeAppendix($route: Route, $router: VueRouter, appendix: string, additionals: any = {}): Promise<any> {
        if (!$route.name) {
            return Promise.resolve();
        }
        
        const name: string = $route.name;
        return $router.push({
            name,
            params: {
                ...ApiUtils.extractRequiredParams($route.params),
                appendix,
                ...additionals
            }
        });
    }
    
    public static hasPrivilege(privileges: Privilege[], privId: string | string[]) {
        if (!privId) {
            return true;
        }
    
        const orDefault = CommonModelUtils.getOrDefault(privileges, []);
        if (privId instanceof Array) {
            return privId.find((targetId: string) => orDefault.find((privilege: Privilege) => privilege.privId === targetId));
        } else {
            return orDefault.find((privilege: Privilege) => privilege.privId === privId);
        }
    }

    public static groupBy<K, V>(list: V[], keyGetter: (input: V) => K) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }

    public static getParamKey(route: Route, router: VueRouter, keyName: string): Promise<string> {
        return route.params[keyName]
          ? new Promise((resolve) => {
              resolve(route.params[keyName].toString());
          })
          : new Promise((resolve, reject) => {
              let paramKey = route.params[keyName];
              let intervalCnt = 0;
              const interval = setInterval(() => {
                  if (paramKey) {
                      clearInterval(interval);
                      resolve(paramKey.toString());
                  }
                  if (intervalCnt >= 9) {
                      clearInterval(interval);
                      reject();
                  }
                  intervalCnt++;
                  paramKey = route.params[keyName];

              }, 10);
          });
    }
}
